import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconInfoOffSvg } from "./IconInfoOffSvg.mjs";
const IconInfoOff = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconInfoOffSvg, ...iconProps });
};
export {
  IconInfoOff
};
